import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chart-refresh"
export default class extends Controller {
  connect() {
    console.log("Chart refresh controller connected")
  }
}